import Routes from "./router/Routes";
import ScrollToTop from "./components/ScrollToTop";
import "./assets/css/custom.css";

const App = () => {
    return (
        <>
            <ScrollToTop />
            <Routes />
        </>
    );
};

export default App;
